export default {
  metaTitle: 'Prośba o ocenę',
  welcomeTitle: 'Gratulujemy zakupów!',
  nextStep: 'Następny krok',
  validationError: 'Zaakceptuj Politykę Prywatności, aby przejść dalej',
  common: {
    noData: 'Brak danych',
    change: 'Zmień',
    privacyPolicy: 'Politykę Prywatności',
    accept: 'Akceptuję',
    privacyPolicy2: 'Polityka Prywatności',
    remaining: 'pozostały',
    genderName: 'Podaj płeć',
    edit: 'Edytuj',
    notThisFacility: 'To nie ten punkt?',
    resign: 'Zrezygnuj',
  },
  ratingForm: {
    title: 'Jak oceniasz zakupy w naszym sklepie?',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et sit ultrices tortor diam id consectetur nunc.',
    button: 'Wyślij ocenę',
    city: {
      title: 'Uzupełnij dane o sklepie w którym dokonałaś/eś zakupów',
      label: 'Miasto',
      placeholder: 'Wpisz miasto',
    },
    store: {
      title: 'Wybierz sklep gdzie dokonałaś/eś zakupu:',
      readonlyTitle: 'Oceniany sklep:',
      label: 'Wybierz sklep',
    },
    maxValueLabel: 'Polecam',
    minValueLabel: 'Nie polecam',
    completed: {
      title: 'Dziękujemy za pozytywną ocenę!',
      body: 'Będzie nam miło jeśli zechcesz podzielić się opinią w Google Maps',
      button: 'Oceń w Google Maps',
    },
    optionalEmail: 'Adres e-mail (opcjonalnie)',
    optionalPhoneNumber: 'Numer telefonu (opcjonalnie)',
    shareOpinionLabel: 'Chcesz się podzielić opinią?',
    shareOpinionPlaceholder: 'Twoja opinia (opcjonalnie)',
  },
  reviewForm: {
    title: 'Dziękujemy za ocenę.',
    description:
      'Przekażemy ją do odpowiednich osób i postaramy się, aby Twoje kolejne zakupy były bardziej udane.',
    description2: 'Jeżeli chcesz możesz nam wysłać dodatkowe informacje.',
    yourReview: 'Twoja opinia',
    button: 'Wyślij opinię',
    completed: {
      title: 'Dziękujemy',
      body: 'Twoja opinia jest dla nas bardzo ważna. Dzięki niej łatwiej jest nam się rozwijać.',
    },
  },
  error: {
    title: 'Wystąpił błąd',
    content: 'Spróbuj ponownie później',
  },
  validationErrors: {
    required: 'To pole jest wymagane',
  },
};
